<button
  class="sl-menu-item"
  [id]="'sl-menu-item-' + item.key"
  tabindex="0"
  (click)="onClickItem(item)"
  (keydown)="onKeyDown($event)"
  [disabled]="isDisabled"
  [ngClass]="{ 'sl-menu-item-selected': isSelected }"
  [attr.aria-label]="item.key"
>
  <div
    class="menu-item-content"
    [ngClass]="{
      'menu-item-icon-selected': isSelected && iconSelected
    }"
  >
    @if(icon){
    <span class="material-symbols-outlined"> {{ icon }} </span>
    }
    <sl-typography
      [text]="item.key"
      variant="body-20"
      [weight]="weight"
      [color]="color ?? ''"
      aria-hidden="true"
    ></sl-typography>
    @if(isSelected && iconSelected){
    <span class="material-symbols-outlined" [ngStyle]="{ color: '#737373' }">
      {{ iconSelected }}
    </span>
    }
  </div>
</button>
